import { render, staticRenderFns } from "./paymentConfirm.vue?vue&type=template&id=46aaa11c&scoped=true"
import script from "./paymentConfirm.vue?vue&type=script&lang=js"
export * from "./paymentConfirm.vue?vue&type=script&lang=js"
import style0 from "./paymentConfirm.vue?vue&type=style&index=0&id=46aaa11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aaa11c",
  null
  
)

export default component.exports